export const DialectDictionary = {
	"NSU":"Norton Sound–Unaliq (northern Norton Sound)",
	"NSK":"Norton Sound–Kotlik (southern Norton Sound)",
	"NS":"Norton Sound (both northern and southern shores)",
	"Y":"Yukon",
	"HBC":"Hooper Bay and Chevak",
	"NI":"Nelson Island",
	"NUN":"Nunivak Island",
	"NUN(A)":"Nunivak Island, from Cup'ig Eskimo Dictionary",
	"K":"Kuskokwim",
	"LK":"Lower Kuskokwim",
	"BB":"Bristol Bay",
	"NR":"Nushagak River",
	"LI":"Lake Iliamna",
	"EG":"Egegik",
	"UK":"Upper Kuskokwim (i.e., around Aniak)",
	"CAN":"Canineq (around Kwigillingok, Kipnuk, Kongiganek, and Chefornak)",
	"MY":"middle Yukon",
	"LY":"Lower Yukon",
	"Hooper Bay":"Hooper Bay",
};



// WEBPACK FOOTER //
// ./src/components/constants/DialectDictionary.js